import "./CardsAdmin.css";
import React from "react";
import Card from 'react-bootstrap/Card';


function template({ titre, icon, nombre, total, text, couleur, photo }) {
  return (
    <div className="cards-admin py-2" >
      <Card style={{ borderLeft: `5px solid ${couleur}` ,objectFit: "cover", color : `${couleur}` }}>
        <Card.Img variant="top" src={photo} />
        <Card.Body>
          <div>
            <span className="h1" style={{color:'#18113c'}}>{nombre}</span>
          </div>
          <div className="d-flex justify-content-between">
            <h5 className="text-uppercase">{titre}</h5>
            {icon}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default template;
